export default {
  form: {
    fullName: 'Vollständiger Name',
    jobTitle: 'Berufsbezeichnung',
    company1: 'ibis hotels/Styles/budget 1 - Unternehmensname',
    address1: 'ibis hotels/Styles/budget 1 - Anschrift',
    company2: 'ibis hotels/Styles/budget 2 - Unternehmensname',
    address2: 'ibis hotels/Styles/budget 2 - Anschrift',
    email: 'Email',
    phone: 'Telefon',
    fax: 'Fax',
    operatingCompanyName: 'Name der Betreibergesellschaft',
    operatingCompanyInfos: 'Betreibergesellschaft Infos',
    operatingCompanyDirectors: 'Geschäftsführer',
    operatingCompanyVat: 'Umsatzsteuer ID Nummer',
    facebookLink: 'Facebook Link',
    instagramLink: 'Instagram Link'
  },
  addNewField: 'Neues Feld hinzufügen',
  editField: 'Bearbeitungsfeld',
  uploadImageDescription:
        'Du kannst ein Bild hochladen oder den öffentlichen Link zu einem Bild hinzufügen'
}
